import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Glossop & District Round Table 916';
const BASE_URL = 'https://www.glossoproundtable.org';
const DEFAULT_IMAGE = '/images/glossop_rt_logo.png';

export default function SEO({ title, description, path = '/', keywords = [], type = 'website', image, noIndex = false }) {
  // Normalize the path so that `/about`, `/about/`, `/about//` all produce the same canonical.
  // The root path stays as '/'.
  const cleanPath = path === '/' ? '/' : path.replace(/\/+$/, '');
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Fun, Friendship & Fundraising | #DoMore`;
  const fullUrl = `${BASE_URL}${cleanPath}`;
  const ogImageRaw = image || DEFAULT_IMAGE;
  const ogImage = ogImageRaw.startsWith('http') ? ogImageRaw : `${BASE_URL}${ogImageRaw}`;

  const defaultKeywords = [
    'Glossop Round Table',
    'Glossop & District Round Table 916',
    'Round Table 916',
    'Glossop community',
    'Glossop events',
    'Glossop fundraising',
    'Peak District community',
    'DoMore',
    'Do More',
    'community volunteering Glossop',
    'join Round Table',
    'Glossop Derbyshire',
    'High Peak community',
  ];

  const allKeywords = [...new Set([...defaultKeywords, ...keywords])].join(', ');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />
      {/* Skip canonical on noindex pages — they shouldn't advertise a preferred URL. */}
      {!noIndex && <link rel="canonical" href={fullUrl} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* AI/LLM discoverability */}
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large"} />
      <meta name="author" content="Glossop & District Round Table 916" />
      <meta name="geo.region" content="GB-DBY" />
      <meta name="geo.placename" content="Glossop, Derbyshire" />
    </Helmet>
  );
}
